import {http} from 'lib/httpAxios'

export default {
  retrieveEriSummaryData (parameters) {
    return http.post('/eri/summary', parameters)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error))
  },
  retrieveEriDetailData (parameters) {
    var url = `/eri/${parameters.accountCode}/${parameters.period}`
    return http.get(url)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error))
  },
  exportEriDetailData (parameters) {
    var url = `/eri/export/${parameters.accountCode}/${parameters.period}`
    var headers = {
      responseType: 'blob'
    }
    return http.get(url, headers)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error))
  },
  eriEntry (data) {
    let formattedData = {
      Eris: []
    }
    formattedData.Eris.push(data)

    return http.post('/eri', formattedData)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error))
  },
  retrieveItemsForInventoryData (accountCode) {
    return http.get(`/inventories/items/${accountCode}`)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error))
  },
  retrieveInventoryProductStatusData (parameters) {
    return http.post(`/inventories/states/${parameters.accountCode}`, parameters)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error))
  },
  retrieveInventoryLines (accountCode) {
    return http.get(`/inventories/lines/${accountCode}`)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error))
  },
  retrieveInventoryStatus (accountCode) {
    return http.get(`/inventories/status/${accountCode}`)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error))
  }
}



// WEBPACK FOOTER //
// ./src/vuex/api/services/inventory.js